/* eslint-disable @typescript-eslint/no-unused-vars */
import type { Maybe } from '@backmarket/utils/types/Maybe'
import { z } from 'zod/mini'

import { createBlockSchema } from '../schemas/create-block-schema'
import type { Equal, ExpectTrue } from '../types/validation'

import { ArticleCardsListSchema } from './article-cards-list'
import type { _ApiBlock } from './block'
import { RefinedProductsApiPropsSchema } from './refined-products'

/* TypeScript */
export type PersonalizedFeedApiProps = {
  technicalName?: Maybe<string>
  title?: Maybe<string>
  feed: string
  fallback: Array<_ApiBlock<'RefinedProducts'> | _ApiBlock<'ArticleCardsList'>>
  forceSingleContent?: Maybe<boolean>
}

/* Schemas */
export const PersonalizedFeedApiPropsSchema = z.object({
  technicalName: z.nullish(z.string()),
  title: z.nullish(z.string()),
  feed: z.string(),
  fallback: z.array(
    z.union([
      createBlockSchema('RefinedProducts', RefinedProductsApiPropsSchema),
      createBlockSchema('ArticleCardsList', ArticleCardsListSchema),
    ]),
  ),
  forceSingleContent: z.nullish(z.boolean()),
})

/* Schemas validation */
type TestPersonalizedFeed = ExpectTrue<
  Equal<
    PersonalizedFeedApiProps,
    z.infer<typeof PersonalizedFeedApiPropsSchema>
  >
>
